// src/js/modal-order-window.js
(function() {
    // Безопасное получение элементов
    function safeQuerySelector(selector) {
        return document.querySelector(selector);
    }
    function safeQuerySelectorAll(selector) {
        return document.querySelectorAll(selector);
    }
    // Получаем ссылки на необходимые элементы
    const backdrop = safeQuerySelector('.backdrop');
    const openModalBtn = safeQuerySelectorAll('[data-modal-open]');
    const closeModalBtn = safeQuerySelector('[data-modal-close]');
    // Функция для открытия модального окна
    function openModal() {
        if (backdrop) {
            backdrop.classList.add('is-visible');
            document.body.classList.add('modal-open');
        }
    }
    // Функция для закрытия модального окна
    function closeModal() {
        if (backdrop) {
            backdrop.classList.remove('is-visible');
            document.body.classList.remove('modal-open');
        }
    }
    // Функция для закрытия модального окна при клике вне его области
    function closeModalBackdrop(event) {
        if (event.currentTarget === event.target) closeModal();
    }
    // Добавляем проверку существования элементов перед навешиванием обработчиков
    function initModalListeners() {
        console.log("\u0418\u043D\u0438\u0446\u0438\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044F listeners");
        if (openModalBtn && openModalBtn.length) openModalBtn.forEach((btn)=>{
            btn.removeEventListener('click', openModal);
            btn.addEventListener('click', openModal);
        });
        if (closeModalBtn) {
            closeModalBtn.removeEventListener('click', closeModal);
            closeModalBtn.addEventListener('click', closeModal);
        }
        if (backdrop) {
            backdrop.removeEventListener('click', closeModalBackdrop);
            backdrop.addEventListener('click', closeModalBackdrop);
        }
        console.log("Listeners \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u044B");
    }
    // Инициализируем listeners после полной загрузки DOM
    document.addEventListener('DOMContentLoaded', initModalListeners);
})();

//# sourceMappingURL=aboutme.163ef4cc.js.map
